import { useGetApiDashboardContrats } from '@/api';
import { USER_TYPE } from '@/enums/userType';
import { useAuth } from '@/hooks/useAuth';

import type { ContractsDashboardResponse } from '@/api/placementApi.schemas';

// Nombre de contrats en cours (phases ENC/RED) par famille, toutes catégories confondues (SCPI et défiscalisation
// comprises), contrairement à /listingcontrats qui ne remonte que les contrats arbitrables.
const countEnCoursByFamille = (data: ContractsDashboardResponse | undefined): Record<string, number> =>
  Object.fromEntries(
    (data?.families ?? []).map((famille) => [famille.famille ?? '', famille.listContrat?.enCours?.length ?? 0])
  );

const useDashboardContratsCount = () => {
  const { user } = useAuth();

  const { data, isSuccess } = useGetApiDashboardContrats({
    query: {
      enabled: user?.type === USER_TYPE.client,
    },
  });

  if (!isSuccess) return undefined;

  const byFamille = countEnCoursByFamille(data);
  const total = Object.values(byFamille).reduce((sum, n) => sum + n, 0);

  return { byFamille, total };
};

export { useDashboardContratsCount };
